import { useState } from 'react';
import { useUnit } from 'effector-react';
import { $accountByIdStore } from '@lib/store';
import { ModalItem } from './modalItem';
import { Button, ColorsEnum, Icon, Modal, Text } from '@shared/widgets';
import SendIcon from '@assets/icons/send.svg';
import CopyIcon from '@assets/icons/copy.svg';

interface IValues {
  name: React.ReactNode;
  value?: React.ReactNode;
}

interface IProps {
  onClose: () => void;
  values: IValues[];
  isOpen: boolean;
}

export const ModalAccountDetails = (props: IProps) => {
  const accountDetailsStore = useUnit($accountByIdStore.store);
  const data = accountDetailsStore.data;

  const [email, setEmail] = useState<string>('');

  const handleAllCopy = async () => {
    const valuesToCopy = props.values.map((item) => `${item.name}\n${item.value ? item.value : ''}`).join('\n\n');
    await navigator.clipboard.writeText(valuesToCopy);
  };
  const mail = props.values.map((item) => `${item.name}: ${item.value ? item.value : ''}%0A%0A`).join('\n\n');

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title='Share account details'>
      <div className='max-w-96'>
        {props.values?.map((item, key) => (
          <ModalItem name={item.name} value={item.value} key={key} icon={<Icon icon={<CopyIcon />} color='primary' />} />
        ))}
        <div className='mt-6 mb-5'>
          <Text className='mb-1.5' color={ColorsEnum.Secondary}>
            Send to e-mail
          </Text>
          <div className='flex'>
            <input
              className='w-full h-10 bg-white dark:bg-soft-black pl-3 shadow-md'
              placeholder='Email'
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              color='primary'
              className='rounded-tl-none rounded-tr-sm rounded-br-sm rounded-bl-none'
              to={`mailto:${email}?subject=Details of account ${data?.name}&body=${mail}`}
            >
              <Icon icon={<SendIcon />} color='inherit' />
            </Button>
          </div>
        </div>
        <div className='flex gap-3 justify-between'>
          <Button fullWidth color='outlined' onClick={handleAllCopy}>
            <Icon icon={<CopyIcon />} color='inherit' />
            Copy to the clipboard
          </Button>
        </div>
      </div>
    </Modal>
  );
};
